import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BillingGroupKind, BillingGroupRow, BillingMspGroup, groupBillingRows, matchesBillingGroup, summarizeBillingGroup } from './billing-msp-groups';

@Component({
  selector: 'app-billing-msp-groups',
  templateUrl: './billing-msp-groups.component.html',
  styleUrls: ['./billing-msp-groups.component.scss']
})
export class BillingMspGroupsComponent implements OnChanges {
  @Input() rows: BillingGroupRow[] = [];
  @Input() kind: BillingGroupKind = 'cellular';
  @Input() readOnly = false;
  @Input() pricingRevision = 0;
  @Input() duplicatesOnly = false;
  @Output() duplicatesOnlyChange = new EventEmitter<boolean>();
  @Output() edited = new EventEmitter<void>();
  groups: BillingMspGroup[] = [];
  expanded = new Set<string>();
  opened = new Set<string>();
  search = '';
  sortKey = 'msp';
  ascending = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rows || changes.kind) this.groups = groupBillingRows(this.rows || [], this.kind);
    if (this.duplicatesOnly) this.openDuplicateGroups();
  }
  summary(group: BillingMspGroup) { return summarizeBillingGroup(group, this.kind, this.duplicatesOnly); }
  get visibleGroups(): BillingMspGroup[] {
    return this.groups.filter(group => matchesBillingGroup(group, this.kind, this.search, this.duplicatesOnly)).sort((a, b) => {
      const left = this.sortKey === 'msp' ? a.msp : this.summary(a)[this.sortKey];
      const right = this.sortKey === 'msp' ? b.msp : this.summary(b)[this.sortKey];
      const result = typeof left === 'number' && typeof right === 'number' ? left - right : String(left).localeCompare(String(right));
      return this.ascending ? result : -result;
    });
  }
  sort(key: string): void { this.ascending = key === this.sortKey ? !this.ascending : true; this.sortKey = key; }
  sortState(key: string): string { return key === this.sortKey ? this.ascending ? 'ascending' : 'descending' : 'none'; }
  toggle(group: BillingMspGroup): void {
    this.opened.add(group.key);
    if (this.expanded.has(group.key)) this.expanded.delete(group.key); else this.expanded.add(group.key);
  }
  setDuplicates(value: boolean): void {
    this.duplicatesOnly = value;
    if (value) this.openDuplicateGroups();
    this.duplicatesOnlyChange.emit(value);
  }
  trackGroup(index: number, group: BillingMspGroup): string { return group.key; }
  private openDuplicateGroups(): void {
    this.groups.filter(group => group.rows.some(row => row.hasDuplicateMac)).forEach(group => {
      this.expanded.add(group.key); this.opened.add(group.key);
    });
  }
}
